import React, { useState } from 'react'
import { supabase } from '../lib/supabase'

export default function ContactForm({ creatorId, creatorName, initialMessage = '' }) {
  const [form, setForm] = useState({ name: '', email: '', message: initialMessage })
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      const { error: err } = await supabase.from('enquiries').insert({
        creator_id: creatorId,
        sender_name: form.name,
        sender_email: form.email,
        message: form.message,
      })
      if (err) throw err
      setSuccess(true)
    } catch (err) {
      setError('Failed to send. Please try again.')
    }
    setLoading(false)
  }

  if (success) return (
    <div className="success-msg" style={{ textAlign: 'center', padding: 24 }}>
      Message sent to {creatorName}. They'll be in touch.
    </div>
  )

  return (
    <div>
      <h3 style={{ marginBottom: 16 }}>Contact {creatorName}</h3>
      {error && <div className="error-msg" style={{ marginBottom: 16 }}>{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Your name</label>
          <input type="text" placeholder="Jane Smith" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} required />
        </div>
        <div className="form-group">
          <label>Your email</label>
          <input type="email" placeholder="jane@example.com" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required />
        </div>
        <div className="form-group">
          <label>Message</label>
          <textarea rows={4} placeholder="I'd like to commission..." value={form.message} onChange={e => setForm(f => ({ ...f, message: e.target.value }))} required />
        </div>
        <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
          {loading ? <span className="loading-spinner" /> : 'Send message →'}
        </button>
      </form>
    </div>
  )
}
